'use client';

import Link from 'next/link';
import { ExternalLink, Book, Hand } from 'lucide-react';
import { useSite } from '@/lib/site-context';
import './Footer.scss';

export function FooterLinks() {
  return (
    <>
      <Link href="/about">
        About <Hand size={14} />
      </Link>
      <Link href="/docs">
        Docs <Book size={14} />
      </Link>
      <Link href="https://github.com/fullcontrol-xyz/fullcontrol">
        FullControl <ExternalLink size={14} />
      </Link>
    </>
  );
}

export function FooterContent() {
  const site = useSite();
  const footerCopyYear = new Date().getFullYear().toString();
  const footerCopyText = site.id === 'py' 
    ? `© ${footerCopyYear} py2g. python to gcode`
    : `© ${footerCopyYear} js2g. javascript to gcode`;
  
  return (
    <div className="footer-content">
      <p>{ footerCopyText }</p>
      <div className="footer-links">
        <FooterLinks />
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="site-footer">
      <FooterContent />
    </footer>
  );
}
